<template>
    <div class="pa-5" v-if="activeShipment">
        <model-logs-list :logs="activeShipment.logs" :include-title="false"></model-logs-list>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ModelLogsList from "../../../components/model-logs-list.vue";

export default {
    components: { ModelLogsList },
    computed: {
        ...mapState(["user"]),
        ...mapState("ShipmentStore", ["activeShipment"]),
    },
};
</script>